import { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { api } from '../../../../services/api'

export const usePedidoSpotService = () => {
  const getInitialFilters = () => {
    const searchParams = new URLSearchParams(window.location.search)
    return {
      data_inicial: searchParams.get('data_inicial') || '',
      data_final: searchParams.get('data_final') || '',
      numero_pedido_innovation: searchParams.get('numero_pedido_innovation') || '',
      numero_pedido_spot: searchParams.get('numero_pedido_spot') || '',
    }
  }

  const [filtros, setFiltros] = useState(getInitialFilters())
  const [pedidosFiltrados, setPedidosFiltrados] = useState([])

  const fetchPedidosSpot = async () => {
    let url = '/site/v2/controle-compras/busca-relatorio-compras'
    const params = new URLSearchParams()

    if (filtros.data_inicial) {
      params.append('data_inicial', filtros.data_inicial)
    }

    if (filtros.data_final) {
      params.append('data_final', filtros.data_final)
    }

    if (filtros.numero_pedido_innovation) {
      params.append('numero_pedido_innovation', filtros.numero_pedido_innovation)
    }

    if (filtros.numero_pedido_spot) {
      params.append('numero_pedido_spot', filtros.numero_pedido_spot)
    }

    const queryString = params.toString()
    if (queryString) {
      url += `?${queryString}`
    }

    try {
      const response = await api.get(url)
      return response.data
    } catch (error) {
      throw new Error('Erro ao buscar relatório de pedidos SPOT')
    }
  }

  const { data, isLoading, error, refetch, isRefetching } = useQuery(['pedidos-spot', filtros], fetchPedidosSpot, {
    refetchOnWindowFocus: false,
    refetchInterval: 300000, // 5 minutos
  })

  const mapearDadosAPI = (pedidosAPI) => {
    if (!Array.isArray(pedidosAPI)) return []

    return pedidosAPI.map((pedido, index) => {
      const valorTotalItens = pedido.itens.reduce((total, item) => {
        return total + (item.preco_unitario ? item.quantidade_solicitada * item.preco_unitario : 0)
      }, 0)

      const observacoes = pedido.itens
        .map((item) => item.observacao)
        .filter((obs) => obs !== null && obs !== undefined)
        .join('; ')

      let dataFormatada = pedido.data_pedido
      if (dataFormatada && dataFormatada.includes('/')) {
        const [dia, mes, ano] = dataFormatada.split('/')
        dataFormatada = `${ano}-${mes}-${dia}`
      }

      return {
        id: index + 1, // Gerar um ID único (temporário)
        data_pedido: dataFormatada,
        numero_pedido_spot: pedido.ordem_pedido || 'Não informado',
        numero_pedido_innovation: pedido.pedido_compra ? pedido.pedido_compra.toString() : 'Não informado',
        empresa: pedido.empresa || 'Innovation',
        fornecedor: pedido.fornecedor || 'SPOT',
        cnpj_fornecedor: pedido.cnpj_fornecedor || '',
        valor_total: pedido.total_pedido || valorTotalItens || 0,
        status: pedido.status_pedido || 'Não informado',
        data_previsao_entrega: pedido.data_previsao_entrega || '',
        transportadora: pedido.transportadora || '',
        codigo_rastreio: pedido.codigo_rastreio || '',
        link_pedido_compra: pedido.linkped_compra || '',
        itens: pedido.itens.map((item, idx) => ({
          id: idx + 1,
          nome: item.sku || 'Item não identificado',
          quantidade: item.quantidade_solicitada || 0,
          valor_unitario: item.preco_unitario || 0,
          tipo_linha: item.tipo_linha || '',
          aguardando_arte: item.aguardando_arte || false,
          amostra: item.amostra || false,
          status: item.status_item || 'Não informado',
          observacao: item.observacao || '',
        })),
        observacoes: observacoes || '',
        forma_pagamento: pedido.forma_pagamento || 'Não informado',
        responsavel_compra: pedido.responsavel_compra || 'Não informado',
      }
    })
  }

  useEffect(() => {
    if (!data) return

    try {
      const dadosMapeados = mapearDadosAPI(data)
      setPedidosFiltrados(dadosMapeados)
    } catch (error) {
      console.error('Erro ao processar dados da API:', error)
      setPedidosFiltrados([])
    }
  }, [data])

  const aplicarFiltros = (novosFiltros) => {
    setFiltros(novosFiltros)
  }

  const excluirPedido = async (pedidoId, ordemPedido) => {
    try {
      const response = await api.post('/site/v2/controle-compras/cancelar-pedido-spot', {
        ordem_pedido: ordemPedido,
      })

      if (response.data && response.data.cancelado) {
        setPedidosFiltrados((prev) => prev.map((pedido) => (pedido.id === pedidoId ? { ...pedido, status: 'cancelado' } : pedido)))

        return {
          success: true,
          message: response.data.mensagem || 'Pedido cancelado com sucesso.',
        }
      } else {
        throw new Error(response.data?.mensagem || 'Não foi possível cancelar o pedido.')
      }
    } catch (error) {
      console.error('Erro ao cancelar pedido:', error)
      throw new Error(error.response?.data?.mensagem || error.message || 'Erro ao cancelar pedido.')
    }
  }

  return {
    pedidos: pedidosFiltrados,
    isLoading,
    error,
    isRefetching,
    refetch,
    filtros,
    aplicarFiltros,
    excluirPedido,
  }
}
